import React, { forwardRef } from 'react';
import { Button } from '@chakra-ui/react';

// eslint-disable-next-line react/prop-types
const CustomDatePicker = forwardRef(({ value, onClick }, ref) => (
  <Button onClick={onClick} ref={ref}>
    {value}
  </Button>
));

export default CustomDatePicker;

